import { OnInit } from '@angular/core';
var GmailContactRowComponent = /** @class */ (function () {
    function GmailContactRowComponent() {
        this.contact = {};
    }
    GmailContactRowComponent.prototype.ngOnInit = function () {
    };
    GmailContactRowComponent.prototype.ngOnDestroy = function () {
    };
    return GmailContactRowComponent;
}());
export { GmailContactRowComponent };
//# sourceMappingURL=gmailcontactrow.component.js.map